import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { logSupabaseConnectionStatus } from "@shared/integrations/supabase/connectionCheck";

void logSupabaseConnectionStatus();

createRoot(document.getElementById("root")!).render(<App />);
